var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 42,
    viewBox: "0 0 57 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0846 17.0833C21.2498 17.0833 24.6263 13.7068 24.6263 9.54166C24.6263 5.37652 21.2498 2 17.0846 2C12.9195 2 9.54297 5.37652 9.54297 9.54166C9.54297 13.7068 12.9195 17.0833 17.0846 17.0833Z",
    stroke: "#7F5FEE",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1667 32.1667C32.1667 36.3319 32.1667 39.7083 17.0833 39.7083C2 39.7083 2 36.3319 2 32.1667C2 28.0014 8.75303 24.625 17.0833 24.625C25.4135 24.625 32.1667 28.0014 32.1667 32.1667Z",
    stroke: "#7F5FEE",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7904 20.8535H39.707",
    stroke: "#7F5FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7917 9.54102H35.9375",
    stroke: "#7F5FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M54.793 32.166H43.4805",
    stroke: "#7F5FEE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportContactIcon);
export default __webpack_public_path__ + "static/media/importContactIcon.66e1b3dbee12e92c7e9e9eadd8b7211d.svg";
export { ForwardRef as ReactComponent };